import React from 'react'
import { get } from 'lodash'
import AD from 'react-google-publisher-tag';
import StackedArticle from './StackedArticle.js'
import './styles.css'


class StackedArticles extends React.Component {
	render() {
		const layout = get(this.props.layout, 'settings')
		const adTag  = get(this.props,'data.metadataMap.adTag', null)
		const adFrequency = parseInt(layout.adFrequency, 10)

		const articles = this.props.data.contentData
		return (
			<div className={`stacked-articles ${layout.imagePlacement}`}>
					<div className="stacked-articles-items">
					{
						articles.map((article, i) => {
							return (
								<div className="stacked-article-container" key={i}>
									<StackedArticle article={article} />
									{adTag && adFrequency && (((i + 1) % adFrequency === 0) ? <div className="article-ad"><AD path={adTag} dimensions={[[970, 90], [728, 90], [320, 50]]} /></div> : '')}
								</div>
							)
						})
					}
					</div>
			</div>
		)
	}
}

export default StackedArticles